import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { SdSpyTargetDirective } from '@seb/web-design-system/core';
import { SdTipsComponent } from '@seb/web-design-system/tips';

import { transformHeadlineLevelToTitleLevel } from '../../../mappers';
import { AbstractComponent } from '../abstract-component.component';
import { TipsParagraphComponentInterface } from '../../../models';

@Component({
  selector: 'wc-tips-paragraph',
  templateUrl: './tips-paragraph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTipsComponent,
    SdSpyTargetDirective
  ]
})
export class TipsParagraphComponent extends AbstractComponent<TipsParagraphComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  icon = 'icon-brand-xs';
  titleLevel?: number;
  content?: string;
  title?: string;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  override mandatoryFunction = (cmp: TipsParagraphComponentInterface): boolean => {
    return !!cmp.title && !!cmp.content;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.subscribe((cmp: TipsParagraphComponentInterface) => {
        this.title = cmp.title;
        this.content = cmp.content;
        this.titleLevel = transformHeadlineLevelToTitleLevel(cmp.titleLevel);
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
